var COMMUNITIES = [
  {
    id: '001',
    name: {
      es: 'Tinto',
      en: 'Tinto',
    },
    provinces: [
      {
        id: '001-001',
        ciudad: {
          x: '53%',
          y: '32%',
          vino: 'Garnacha',
          descripcion:
            "Su etimología deriva de la palabra 'granate' que hace referencia a su color. Originaria del valle del Ebro, es la variedad más importante y cultivada en Aragón. Se ha extendido por otras regiones de España y el sur de Francia, donde los vinos obtenidos difieren mucho según su zona de cultivo. Prospera en todo tipo de suelos, y crece muy bien en laderas. Su uso en rosados, combinada con otras variedades de uva, da como resultado vinos de gran calidad.",
          image:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/GARNACHA.webp?v=1723572674',
          localizacion: 'Aragón, La Rioja, Navarra, Cataluña',
          opinion_summelier: 'https://www.youtube.com/embed/gRW5K4c6jX0',
          link_tienda: 'https://raicesibericas.com/products/raices-garnacha',
          modalBoton: 'Ver más',
          modalTexto: 'Detalles sobre Garnacha',
          modalVideo:
            'https://www.youtube.com/embed/cup0E7BS_bY?si=myTE0bET2PTcbH-D',
          modalMap:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/GARNACHA.png?v=1725622921',
        },
        order: 12,
      },
      {
        id: '001-002',
        ciudad: {
          x: '19%',
          y: '20%',
          vino: 'Mencía',
          descripcion:
            'Mencía es la variedad tinta principal de la D.O. Bierzo, donde se encuentran la mayoría de los viñedos. Se está expandiendo por Galicia (Ribeira Sacra, Valdeorras, Monterrei) y el norte de Portugal. Se dice que su cultivo aumentó gracias a los monjes del noroeste de España, aunque ya se cultivaba en la época romana. Tras recuperarse de la epidemia de filoxera a finales del siglo XIX, la Mencía se ha utilizado para elaborar vinos afrutados, aromáticos, de color intenso y potencial de guarda. Muchos la denominan coloquialmente como la Pinot Noir española debido a sus aromas sorprendentes y a sus taninos suaves y aterciopelados.',
          image:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/MENCIA.webp?v=1723572674',
          localizacion: 'León, Galicia ',
          opinion_summelier: 'https://www.youtube.com/embed/gRW5K4c6jX0',
          link_tienda: 'https://raicesibericas.com/products/raices-mencia',
          modalBoton: 'Ver más',
          modalTexto: 'Detalles sobre Mencía',
          modalVideo: 'https://www.youtube.com/embed/exampleVideo',
          modalMap:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/MENCIA.png?v=1725622923',
        },
        order: 13,
      },
      {
        id: '001-003',
        ciudad: {
          x: '60%',
          y: '50%',
          vino: 'Bobal',
          descripcion:
            'La variedad tinta Bobal es originaria del sudeste de España. Es la variedad principal de la D.O. Utiel-Requena, una pequeña meseta en la provincia de Valencia. También la podemos encontrar en Castilla-La Mancha, sobre todo en Cuenca, Albacete y la D.O. Manchuela. La bobal se adapta bien a suelos pedregosos, aluviales o de esquisto, y se utiliza principalmente en coupages de rosados o como monovarietal en vinos tintos.',
          image:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/BOBAL.webp?v=1723572675',
          localizacion: 'Valencia, Castilla-La Mancha',
          opinion_summelier: 'https://www.youtube.com/embed/gRW5K4c6jX0',
          link_tienda: 'https://raicesibericas.com/products/raices-bobal',
          modalBoton: 'Ver más',
          modalTexto: 'Detalles sobre Bobal',
          modalVideo: 'https://www.youtube.com/embed/exampleVideo',
          modalMap:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/BOBAL.png?v=1725622923',
        },
        order: 14,
      },
      {
        id: '001-004',
        ciudad: {
          x: '55%',
          y: '30%',
          vino: 'Tempranillo',
          descripcion:
            'Aunque mucha gente piensa que el origen de esta variedad está en La Rioja, en realidad está en Valdepeñas (Ciudad Real). Es la variedad tinta más cultivada en España, con más de 200.000 hectáreas. En cada lugar recibe un nombre: Tinta del País, Cencibel, Tinta de Toro, Ull de Llebre, o Tinta fina, entre otros. De racimos grandes y compactos, la Tempranillo madura temprano, de ahí su nombre. Da vinos de acidez media/baja, afrutados, y suaves, fáciles de beber.',
          image:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/TEMPRANILLO.webp?v=1723572673',
          localizacion:
            'Castilla-La Mancha, La Rioja, Navarra, Aragón, Castilla y León, Madrid, Extremadura, Galicia, Cataluña',
          opinion_summelier: 'https://www.youtube.com/embed/gRW5K4c6jX0',
          link_tienda: 'https://raicesibericas.com/products/raices-tempranillo',
          modalBoton: 'Ver más',
          modalTexto: 'Detalles sobre Tempranillo',
          modalVideo: 'https://www.youtube.com/embed/exampleVideo',
          modalMap:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/TEMPRANILLO.png?v=1725622922',
        },
        order: 15,
      },
      {
        id: '001-005',
        ciudad: {
          x: '55%',
          y: '64%',
          vino: 'Monastrell',
          descripcion:
            'Se cree que esta variedad tinta, también conocida como Mouvedre o Mataró, la trajeron los fenicios hasta Cataluña en el 500 a.C. Hoy en día no solo la encontramos allí, sino que está repartida por gran parte de España: en Valencia, Alicante, Albacete, La Rioja, Madrid o Murcia. Más allá de en nuestro país, esta variedad se ha cultivado en viñedos de todo el Mediterráneo occidental durante siglos. También se ha extendido ampliamente por California y el sur de Australia.',
          image:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/MONASTRELL.webp?v=1723572675',
          localizacion:
            'Murcia, Cataluña, Valencia, Castilla-La Mancha, La Rioja, Madrid, Andalucía, Aragón',
          opinion_summelier: 'https://www.youtube.com/embed/gRW5K4c6jX0',
          link_tienda: 'https://raicesibericas.com/products/raices-monastrell',
          modalBoton: 'Ver más',
          modalTexto: 'Detalles sobre Monastrell',
          modalVideo: 'https://www.youtube.com/embed/exampleVideo',
          modalMap:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/MONASTRELL.png?v=1725622923',
        },
        order: 16,
      },
      {
        id: '001-006',
        ciudad: {
          x: '29%',
          y: '19%',
          vino: 'Prieto Picudo',
          descripcion:
            'Prieto Picudo es una uva de vino tinto de piel oscura, muy rara, que crece principalmente en León y Zamora. Prospera en los terrenos más desafiantes, cálidos y secos debido a su alta resistencia a las altas temperaturas y a las sequías. Un vino típico de Prieto Picudo contiene taninos moderados y conserva una buena acidez. Su nombre deriva de la forma de las bayas y el racimo, prieto y con forma picuda, ovalada y acabado en punta. Hay poco más de 4.000 hectáreas en España, con las que se producen tintos y rosados.',
          image:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/PRIETO_PICUDO.webp?v=1723572675',
          localizacion: 'León',
          opinion_summelier: 'https://www.youtube.com/embed/gRW5K4c6jX0',
          link_tienda:
            'https://raicesibericas.com/products/raices-prieto-picudo',
          modalBoton: 'Ver más',
          modalTexto: 'Detalles sobre Prieto Picudo',
          modalVideo: 'https://www.youtube.com/embed/exampleVideo',
          modalMap:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/PRIETO_PICUDO.png?v=1725622923',
        },
        order: 4,
      },
      {
        id: '001-007',
        ciudad: {
          x: '23%',
          y: '34%',
          vino: 'Juan Garcia',
          descripcion:
            'Variedad autóctona de las provincias de Zamora y Salamanca (Castilla y León), de la zona de Arribes del Duero.  Esta variedad es una de las grandes desconocidas pero más sorprendentes de la Península Ibérica. Otro de los nombres que recibe es Negra en los pueblos ribereños de Portugal o Mouratón en Galicia. Carece de una brotación temprana, lo que descarta el riesgo de heladas en primavera. No presenta mucha acidez, ni produce una graduación alta, dando como resultado vinos suaves y estructurados.',
          image:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/JUAN_GARCIA.webp?v=1723572674',
          localizacion: 'Zamora y Salamanca',
          opinion_summelier: 'https://www.youtube.com/embed/gRW5K4c6jX0',
          link_tienda:
            'https://raicesibericas.com/es-en/products/raices-juan-garcia',
          modalBoton: 'Ver más',
          modalTexto: 'Detalles sobre Juan Garcia',
          modalVideo: 'https://www.youtube.com/embed/exampleVideo',
          modalMap:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/JUAN_GARCIA.png?v=1725622922',
        },
        order: 5,
      },
      // {
      //   id: "001-008",
      //   ciudad: {
      //     x: "65%",
      //     y: "41%",
      //     vino: "Mazuela",
      //     descripcion:
      //     "Cariñena is a variety with many names: Mazuelo in Rioja and Samsó in Catalonia. It was once one of the dominant grape varieties in many regions of Spain and southern France. In fact, its popularity in areas like Languedoc-Roussillon made it the most planted grape variety at one point in the 20th century. However, such high yields resulted in rather low quality wine, tasteless wine, which severely affected the grape’s reputation and led to a signifi cant decrease in plantations.",
      //     image: "https://cdn.shopify.com/s/files/1/0604/5702/5674/files/JUAN_GARCIA.webp?v=1723572674",
      //     localizacion: "Noroeste",
      //     opinion_summelier: "https://www.youtube.com/embed/gRW5K4c6jX0",
      //     link_tienda: "https://raicesibericas.com/products/raices-mazuela",
      //     modalBoton: "Ver más",
      //     modalTexto: "Detalles sobre Mazuela",
      //     modalVideo: "https://www.youtube.com/embed/exampleVideo",
      //     modalMap: "https://cdn.shopify.com/s/files/1/0604/5702/5674/files/MALVAR.png?v=1725622922"
      //   },
      //   order: 19
      // },
      // {
      //   id: "001-009",
      //   ciudad: {
      //     x: "68%",
      //     y: "20%",
      //     vino: "Graciano",
      //     descripcion:
      //     "La variedad tinta Graciano se cultiva principalmente en Navarra y La Rioja aunque está presente en otras regiones de España como Castilla-La Mancha, Aragón o Castilla y León. A la Graciano le gustan los suelos frescos. Su nombre viene de la 'Gracia' que proporciona esta uva al mezclarla con otras variedades, en términos tanto de aromas como de sabor. En España hay plantadas unas 2.000 hectáreas de Graciano. .",
      //     image: "https://cdn.shopify.com/s/files/1/0604/5702/5674/files/JUAN_GARCIA.webp?v=1723572674",
      //     localizacion: "Noroeste",
      //     opinion_summelier: "https://www.youtube.com/embed/gRW5K4c6jX0",
      //     link_tienda: "https://raicesibericas.com/products/raices-graciano",
      //     modalBoton: "Ver más",
      //     modalTexto: "Detalles sobre RAICES GRACIANO",
      //     modalVideo: "https://www.youtube.com/embed/exampleVideo",
      //     modalMap: "https://cdn.shopify.com/s/files/1/0604/5702/5674/files/GRACIANO.png?v=1725622922"
      //   },
      //   order: 20
      // },
      {
        id: '001-010',
        ciudad: {
          x: '20%',
          y: '38%',
          vino: 'Rufete',
          descripcion:
            'Variedad autóctona de la comarca de la Sierra de Salamanca. También se puede encontrar al norte de esta sierra, en Zamora, al sur, en Cáceres, y en Arribes del Duero. Actualmente, estos viñedos se encuentran en proceso de recuperación, gracias a su gran potencial productivo. Suelen crecer en terrazas de pizarra o granito, y le favorecen los días soleados y las noches muy frías, en suelos bien irrigados. Es una uva de maduración temprana.',
          image:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/RUFETE.webp?v=1723572673',
          localizacion: 'Zamora, Salamanca y Cáceres',
          opinion_summelier: 'https://www.youtube.com/embed/gRW5K4c6jX0',
          link_tienda: 'https://raicesibericas.com/products/raices-rufete',
          modalBoton: 'Ver más',
          modalTexto: 'Detalles sobre Rufete',
          modalVideo: 'https://www.youtube.com/embed/exampleVideo',
          modalMap:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/RUFETE.png?v=1725622923',
        },
        order: 6,
      },
      {
        id: '001-011',
        ciudad: {
          x: '58%',
          y: '50%',
          vino: 'Tintorera',
          descripcion:
            'Esta variedad de uva estuvo prácticamente olvidada durante años. Producida como Alicante Bouschet, es similar a la garnacha, pero con granos más pequeños. Le gustan los suelos profundos y la fertilización rica en fósforo. Su cultivo en espaldera puede mejorar significativamente tanto la calidad como la producción de la uva. Se utiliza habitualmente para enriquecer el color de otros vinos, algo que se hace desde la Edad Media. Hoy en día la encontramos en casi todas las regiones vinícolas de España, con más de 25.000 hectáreas plantadas.',
          image:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/TINTORERA.webp?v=1723572673',
          localizacion:
            'Castilla-La Mancha, Valencia, Asturias, Aragón, Castilla y León, Extremadura',
          opinion_summelier: 'https://www.youtube.com/embed/gRW5K4c6jX0',
          link_tienda: 'https://raicesibericas.com/products/raices-tintorera',
          modalBoton: 'Ver más',
          modalTexto: 'Detalles sobre Tintorera',
          modalVideo: 'https://www.youtube.com/embed/exampleVideo',
          modalMap:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/TINTORERA.png?v=1725622924',
        },
        order: 17,
      },
    ],
  },
  {
    id: '002',
    name: {
      es: 'Blanco',
      en: 'Blanco',
    },
    provinces: [
      {
        id: '002-001',
        ciudad: {
          x: '13%',
          y: '20%',
          vino: 'Albariño',
          descripcion:
            'Uva blanca originaria de Galicia producida principalmente en la región de Pontevedra. Esta es la variedad principal de la D.O. Rías Baixas con especial protagonismo en las zonas de Salnés, Ribeira Sacra y Ribeiro. También se puede encontrar en el norte de Portugal. Los mejores lugares para cultivarla se encuentran en el microclima del Atlántico. Necesita temperaturas suaves, abundantes precipitaciones, clima cálido y suelos arenosos. Por lo general, se cultiva en enrejados. En España hay plantadas 5.800 hectáreas de esta variedad.',
          image:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/ALBARINO.webp?v=1723572674',
          localizacion: 'Galicia',
          opinion_summelier: 'https://www.youtube.com/embed/gRW5K4c6jX0',
          link_tienda: 'https://raicesibericas.com/products/raices-albarino',
          modalBoton: 'Ver más',
          modalTexto: 'Detalles sobre Albariño',
          modalVideo: 'https://www.youtube.com/embed/exampleVideo',
          modalMap:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/ALBARINO.png?v=1725622922',
        },
        order: 8,
      },
      {
        id: '002-002',
        ciudad: {
          x: '29%',
          y: '28%',
          vino: 'Verdejo',
          descripcion:
            'Variedad blanca que tiene su origen en la región del Duero. Es la base de los vinos de Rueda, pero también se puede encontrar en Cigales, Tierra de León, Cea, Zamora, Asturias, Cantabria, incluso en las Islas Canarias. Además, se encuentra en Portugal y Australia. De racimo y uvas más bien pequeñas, esta vid es resistente a la sequía, y se adapta bien a terrenos pobres y pedregosos. Se suele recolectar de noche, para que sufra una menor oxidación. La Verdejo produce vinos equilibrados y frescos, con un toque ácido y afrutado.',
          image:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/VERDEJO.webp?v=1723572674',
          localizacion: 'Noroeste',
          opinion_summelier: 'https://www.youtube.com/embed/gRW5K4c6jX0',
          link_tienda: 'https://raicesibericas.com/products/raices-verdejo',
          modalBoton: 'Ver más',
          modalTexto: 'Detalles sobre Verdejo',
          modalVideo: 'https://www.youtube.com/embed/exampleVideo',
          modalMap:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/VERDEJO.png?v=1725622923',
        },
        order: 7,
      },
      {
        id: '002-003',
        ciudad: {
          x: '21%',
          y: '18%',
          vino: 'Godello',
          descripcion:
            'Variedad blanca nativa del noroeste de España, probablemente originaria de las laderas del río Sil, en la D.O. Valdeorras. Actualmente se encuentra en toda Galicia, el norte de Portugal, en la D.O. Bierzo y en algunas denominaciones de las Islas Canarias. Encontramos 1.200 hectáreas de Godello plantadas en España. Uva de gran potencial aromático, de racimos pequeños y densos, la Godello produce vinos untuosos, equilibrados, con toques cítricos, florales y afrutados, de intenso aroma.',
          image:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/GODELLO.webp?v=1723572673',
          localizacion: 'Galicia, León, Islas Canarias',
          opinion_summelier: 'https://www.youtube.com/embed/gRW5K4c6jX0',
          link_tienda: 'https://raicesibericas.com/products/raices-godello',
          modalBoton: 'Ver más',
          modalTexto: 'Detalles sobre Godello',
          modalVideo: 'https://www.youtube.com/embed/exampleVideo',
          modalMap:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/GODELLO.png?v=1725622922',
        },
        order: 9,
      },
      // {
      //   id: "002-004",
      //   ciudad: {
      //     x: "38%",
      //     y: "48%",
      //     vino: "Palomino",
      //     descripcion:
      //     "Palomino is a white grape variety that is most famously used in the production of Sherry wines in the Andalusia region of southern Spain. It is known for its ability to produce wines with a light, delicate flavor and a slightly nutty finish. Palomino grapes are typically harvested in September and are often blended with other grape varieties to create a range of different styles of Sherry.",
      //     image: "https://cdn.shopify.com/s/files/1/0604/5702/5674/files/VERDEJO.webp?v=1723572674",
      //     localizacion: "Noroeste",
      //     opinion_summelier: "https://www.youtube.com/embed/gRW5K4c6jX0",
      //     link_tienda: "https://raicesibericas.com/products/raices-tempranillo",
      //     modalBoton: "Ver más",
      //     modalTexto: "Detalles sobre Palomino",
      //     modalVideo: "https://www.youtube.com/embed/exampleVideo",
      //     modalMap: "https://cdn.shopify.com/s/files/1/0604/5702/5674/files/GODELLO.png?v=1725622922"
      //   },
      //   order: 18
      // },
      // {
      //   id: "002-005",
      //   ciudad: {
      //     x: "65%",
      //     y: "36%",
      //     vino: "Macabeo",
      //     descripcion:
      //     "Also known as Viura in the Rioja region, Macabeo is a white grape variety that is widely planted in the northeastern regions of Spain, particularly in Catalonia and Aragon. It is known for its versatility and is often used in the production of both still and sparkling wines. Macabeo grapes produce wines with a fresh, fruity flavor and a slightly floral aroma.",
      //     image: "https://cdn.shopify.com/s/files/1/0604/5702/5674/files/VERDEJO.webp?v=1723572674",
      //     localizacion: "Noroeste",
      //     opinion_summelier: "https://www.youtube.com/embed/gRW5K4c6jX0",
      //     link_tienda: "https://raicesibericas.com/products/raices-tempranillo",
      //     modalBoton: "Ver más",
      //     modalTexto: "Detalles sobre RAICES MACABEO",
      //     modalVideo: "https://www.youtube.com/embed/exampleVideo",
      //     modalMap: "https://cdn.shopify.com/s/files/1/0604/5702/5674/files/GODELLO.png?v=1725622922"

      //   },
      //   order: 5
      // },
      {
        id: '001-012',
        ciudad: {
          x: '23%',
          y: '16%',
          vino: 'Albarín',
          descripcion:
            'Esta es una variedad de uva originaria de Asturias que se ha extendido a Cantabria y Castilla y León. Casi desapareció hasta que fue replantada por viticultores hace unos diez años. Hoy en día, sólo existen unas 66 hectáreas de vides de Albarín en todo el mundo. Algunos viticultores cultivan enredaderas que tienen más de 100 años. A veces se confunde con el Albariño, pero no existe relación entre ambas. La Alabarín tiene un toque moscatelado, y se caracteriza por su frescura e intensidad aromática.',
          image:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/ALBARIN.webp?v=1723572672',
          localizacion: 'Asturias, Cantabria y Castilla y León',
          opinion_summelier: 'https://www.youtube.com/embed/gRW5K4c6jX0',
          link_tienda: 'https://raicesibericas.com/es-en/products/vino-albarin',
          modalBoton: 'VerM más',
          modalTexto: 'Detalles sobre Abarín',
          modalVideo: 'https://www.youtube.com/embed/exampleVideo',
          modalMap:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/ALBARIN.png?v=1725622923',
        },
        order: 1,
      },
      {
        id: '002-007',
        ciudad: {
          x: '32%',
          y: '30%',
          vino: 'Albillo',
          descripcion:
            'Uva blanca de muy baja producción. Se cultiva principalmente en Castilla y León, concretamente en Ribera de Duero y Ávila, así como en las regiones de Madrid y Galicia. También se utiliza en la DO Cigales para acompañar a la Tempranillo y la Verdejo en la elaboración de sus famosos rosados. Es una variedad apta para envejecer en barrica, con buena acidez y estructura. Si bien existen referencias a vinos elaborados con esta variedad que se remontan al siglo XVII, se ha consumido principalmente como uva de mesa. Algunos autores extranjeros la consideran uno de los secretos mejor guardados de España, ya que es casi imposible de encontrar fuera de sus fronteras.',
          image:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/ALBILLO.webp?v=1723572673',
          localizacion: 'Castilla y León, Madrid y Galicia',
          opinion_summelier: 'https://www.youtube.com/embed/gRW5K4c6jX0',
          link_tienda:
            'https://raicesibericas.com/es-en/products/raices-albillo',
          modalBoton: 'Ver más',
          modalTexto: 'Detalles sobre Albillo',
          modalVideo: 'https://www.youtube.com/embed/exampleVideo',
          modalMap:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/ALBILLO.png?v=1725622923',
        },
        order: 2,
      },
      {
        id: '002-007',
        ciudad: {
          x: '39%',
          y: '40%',
          vino: 'Malvar',
          descripcion:
            'Variedad de uva blanca, cultivada predominantemente en la provincia de Madrid. También se puede encontrar en la ribera del Guadiana, Cuenca, Cáceres y Castilla-La Mancha, donde se conoce como Mondéjar. Se adapta a todo tipo de suelos, aunque prefiere los calizos. De racimos grandes, con uvas de tamaño mediano, de buena acidez y carga de azúcar, dan vinos jóvenes y aromáticos. A finales del siglo XX había plantadas en todo el mundo unas 2.500 hectáreas de Malvar.',
          image:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/MALVAR.webp?v=1723572674',
          localizacion: 'Madrid, Castilla-La Mancha y Cáceres',
          opinion_summelier: 'https://www.youtube.com/embed/gRW5K4c6jX0',
          link_tienda: 'https://raicesibericas.com/products/raices-malvar',
          modalBoton: 'Ver más',
          modalTexto: 'Detalles sobre Malvar',
          modalVideo: 'https://www.youtube.com/embed/exampleVideo',
          modalMap:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/MALVAR.png?v=1725622922',
        },
        order: 3,
      },
      {
        id: '002-008',
        ciudad: {
          x: '68%',
          y: '34%',
          vino: 'Garnacha Blanca',
          descripcion:
            'Mutación de la garnacha tinta que se originó en España. Se cultiva principalmente en Tarragona, Zaragoza y Teruel. Es la variedad de uva principal en las denominaciones de Alella, Costers del Segre, Tarragona y Terra Alta. La Garnacha blanca es una variedad muy productiva, de racimo entre mediano y pequeño, con uvas de forma elíptica y hollejo fino. Se adapta a climas cálidos y secos, aunque el clima fresco le hace tener carácter y mayor acidez. Produce vinos de acidez media/alta, ligeros, y con notas afrutadas, herbáceas y florales. ',
          image:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/GARNACHA_BLANCA.webp?v=1723572673',
          localizacion: 'Aragón, Cataluña',
          opinion_summelier: 'https://www.youtube.com/embed/gRW5K4c6jX0',
          link_tienda:
            'https://raicesibericas.com/products/raices-garnacha-blanca',
          modalBoton: 'Ver más',
          modalTexto: 'Detalles sobre Garnacha Blanca',
          modalVideo: 'https://www.youtube.com/embed/exampleVideo',
          modalMap:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/GARNACHA_BLANCA.png?v=1725622923',
        },
        order: 10,
      },
      {
        id: '002-009',
        ciudad: {
          x: '70%',
          y: '35%',
          vino: 'Xarel·lo',
          descripcion:
            'La variedad blanca Xarel·lo, probablemente, tiene su origen en Grecia, pero es en Cataluña donde se desarrolló su cultivo. De piel fina, antiguamente se utilizaba para elaborar mistela debido a su aroma a pasas. Pero hoy en día es una de las tres variedades principales para la elaboración del Cava. Los viñedos que mejor se cultivan de esta variedad son los que se encuentran cercanos al mar, con suelos frescos y poco profundos. En altitudes de unos 400 metros para beneficiarse del sol y la brisa marina.',
          image:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/XAREL-LO.webp?v=1723572674',
          localizacion: 'Cataluña',
          opinion_summelier: 'https://www.youtube.com/embed/gRW5K4c6jX0',
          link_tienda: 'https://raicesibericas.com/products/raices-xarel-lo',
          modalBoton: 'Ver más',
          modalTexto: 'Detalles sobre XAREL·LO',
          modalVideo: 'https://www.youtube.com/embed/exampleVideo',
          modalMap:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/XAREL-LO.png?v=1725622923',
        },
        order: 11,
      },
      {
        id: '002-009',
        ciudad: {
          x: '48%',
          y: '31%',
          vino: 'Moscatel',
          descripcion:
            'Se cree que el origen de esta variedad blanca está en Asia Menor o Grecia. Está muy extendida por España, sobre todo en Valencia, Málaga, Alicante y las Islas Canarias. Y es que se adapta muy bien a los climas cálidos de la costa. Sus racimos son pequeños, al igual que sus uvas. Tradicionalmente, se utilizaba para elaborar vinos dulces, aunque los secos son cada vez más comunes.',
          image:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/MOSCATEL.webp?v=1723572673',
          localizacion:
            'Aragón, Valencia, Andalucía, Islas Canarias, Cataluña, Castilla y León, Castilla-La Mancha',
          opinion_summelier: 'https://www.youtube.com/embed/gRW5K4c6jX0',
          link_tienda: 'https://raicesibericas.com/products/raices-moscatel',
          modalBoton: 'Ver más',
          modalTexto: 'Detalles sobre Moscatel',
          modalVideo: 'https://www.youtube.com/embed/exampleVideo',
          modalMap:
            'https://cdn.shopify.com/s/files/1/0604/5702/5674/files/MOSCATEL.png?v=1725622923',
        },
        order: 18,
      },
    ],
  },
];

let arrayOrder = [];

async function getCommunities() {
  await fetch(mapSvgUrl)
    .then(response => response.text())
    .then(svg => {
      const mapContainer = document.getElementById('mapContainer');
      mapContainer.innerHTML = svg;
    });

  COMMUNITIES.forEach((community, i) => {
    community.provinces.forEach(variety => {
      arrayOrder.push(variety.order);

      const capitalPosition = variety.ciudad;
      const vineName = variety.ciudad.vino;

      const vineIcon = document.createElement('div');
      const vineIconSpam = document.createElement('span');
      const vinePin = document.createElement('div');
      vinePin.classList.add('vinePin');
      vineIconSpam.className = 'vineIconSpam';

      vineIcon.className = 'vineIcon';
      vineIcon.style.position = 'absolute';
      vineIcon.style.left = capitalPosition.x;
      vineIcon.style.top = capitalPosition.y;

      vinePin.style.display = 'block';
      vinePin.style.width = '4px';
      vinePin.style.height = '10px';
      vinePin.style.backgroundColor = 'black';
      vinePin.style.position = 'absolute';
      vinePin.style.left = '50%';
      vinePin.style.top = '100%';
      vinePin.style.transform = 'translateX(-50%)';

      vineIcon.appendChild(vinePin);

      const vineElement = document
        .querySelector('#mapContainer')
        .appendChild(vineIcon);
      vineIcon.appendChild(vineIconSpam);
      vineIconSpam.textContent = vineName;

      if (i == 0) {
        vineIcon.style.backgroundColor = '#d6b36a';
        vineIcon.classList.add('redWine');
      } else {
        vineIcon.style.backgroundColor = '#d6b36a';
        vineIcon.classList.add('whiteWine');
      }

      vineIcon.addEventListener('click', () => {
        const targetId = variety.ciudad.vino;
        window.location.href = `#${targetId}`;
      });
    });
  });
}

getCommunities();

const vineIcons = document.querySelectorAll('.vineIcons');
vineIcons.forEach(icon => {
  icon.addEventListener('click', () => {
    const targetId = variety.ciudad.vino;
    window.location.href = `#${variety.ciudad.vino}`;
  });
});

//Buttons Logic
const redButton = document.querySelector('#redButton');
const whiteButton = document.querySelector('#whiteButton');
const allButton = document.querySelector('#allButton');

redButton.addEventListener('click', redWines);
whiteButton.addEventListener('click', whiteWines);
allButton.addEventListener('click', allWines);

function redWines() {
  document.querySelectorAll('.redWine').forEach(wine => {
    wine.classList.add('d-block');
    wine.classList.remove('d-none');
  });

  document.querySelectorAll('.whiteWine').forEach(wine => {
    wine.classList.add('d-none');
    wine.classList.remove('d-block');
  });
}

function whiteWines() {
  document.querySelectorAll('.redWine').forEach(wine => {
    wine.classList.add('d-none');
    wine.classList.remove('d-block');
  });

  document.querySelectorAll('.whiteWine').forEach(wine => {
    wine.classList.add('d-block');
    wine.classList.remove('d-none');
  });
}

function allWines() {
  document.querySelectorAll('.redWine').forEach(wine => {
    wine.classList.add('d-block');
    wine.classList.remove('d-none');
  });

  document.querySelectorAll('.whiteWine').forEach(wine => {
    wine.classList.add('d-block');
    wine.classList.remove('d-none');
  });
}

window.addEventListener('load', allWines);
